
import { TimelineSection } from "@/types";

export const findSectionForYear = (
  year: string, 
  timelineSections: TimelineSection[], 
  userBirthdate?: string
): TimelineSection | null => {
  console.log('🔍 findSectionForYear called:', {
    year,
    userBirthdate,
    timelineSectionsCount: timelineSections.length,
    firstSection: timelineSections[0]
  });

  if (!year || !timelineSections.length || !userBirthdate) {
    console.log('🔍 findSectionForYear - Missing required data');
    return null;
  }

  const selectedYear = parseInt(year);
  const birthYear = new Date(userBirthdate).getFullYear();
  const userAgeInSelectedYear = selectedYear - birthYear;

  console.log('🔍 findSectionForYear - Age calculation:', {
    selectedYear,
    birthYear,
    userAgeInSelectedYear
  });

  // Find the section that contains this age
  const matchingSection = timelineSections.find(section => {
    const hasAgeData = section.age_from !== undefined && section.age_to !== undefined;
    const ageMatch = hasAgeData && userAgeInSelectedYear >= section.age_from && userAgeInSelectedYear <= section.age_to;
    
    console.log('🔍 findSectionForYear - Checking section:', {
      sectionName: section.name,
      age_from: section.age_from,
      age_to: section.age_to,
      hasAgeData,
      ageMatch,
      userAgeInSelectedYear
    });
    
    return ageMatch;
  });

  console.log('🔍 findSectionForYear - Found matching section:', matchingSection?.name || 'none');
  return matchingSection || null;
};

export const getSectionDisplayMessage = (
  oldSection: TimelineSection | undefined,
  newSection: TimelineSection,
  t: (key: string, options?: any) => string
): string => {
  if (oldSection && oldSection.id !== newSection.id) {
    return t('chat.sectionChangedDueToYear', { 
      oldSection: oldSection.name, 
      newSection: newSection.name 
    });
  }
  return '';
};

export const calculateEntryMovements = (
  timelineSections: TimelineSection[],
  userBirthdate: string,
  entries: Array<{ id: string; year: number; title: string; profile_timeline_section_id: string }>
): Array<{
  entryId: string;
  title: string;
  year: number;
  currentSectionId: string;
  newSectionId: string;
  age: number;
}> => {
  if (!userBirthdate || !timelineSections.length) {
    return [];
  }

  const birthYear = new Date(userBirthdate).getFullYear();
  const movements: Array<{
    entryId: string;
    title: string;
    year: number;
    currentSectionId: string;
    newSectionId: string;
    age: number;
  }> = [];

  entries.forEach(entry => {
    if (!entry.year) return;

    const entryAge = entry.year - birthYear;
    const correctSection = timelineSections.find(section => 
      section.age_from !== undefined && 
      section.age_to !== undefined &&
      entryAge >= section.age_from && 
      entryAge <= section.age_to
    );

    if (correctSection && correctSection.id !== entry.profile_timeline_section_id) {
      movements.push({
        entryId: entry.id,
        title: entry.title,
        year: entry.year,
        currentSectionId: entry.profile_timeline_section_id,
        newSectionId: correctSection.id,
        age: entryAge
      });
    }
  });

  console.log('📊 Calculated entry movements:', {
    totalEntries: entries.length,
    movementsNeeded: movements.length,
    birthYear,
    movements: movements.map(m => ({
      title: m.title,
      year: m.year,
      age: m.age
    }))
  });

  return movements;
};

export const validateEntryAgeRange = (
  year: number,
  userBirthdate: string,
  timelineSections: TimelineSection[]
): {
  isValid: boolean;
  age: number;
  matchingSection: TimelineSection | null;
  warning?: string;
} => {
  const birthYear = new Date(userBirthdate).getFullYear();
  const age = year - birthYear;
  
  const matchingSection = timelineSections.find(section => 
    section.age_from !== undefined && 
    section.age_to !== undefined &&
    age >= section.age_from && 
    age <= section.age_to
  );

  const result = {
    isValid: !!matchingSection,
    age,
    matchingSection: matchingSection || null,
    warning: undefined as string | undefined
  };

  if (!matchingSection) {
    if (age < 0) {
      result.warning = 'Das Jahr liegt vor Ihrem Geburtsjahr.';
    } else if (age > 100) {
      result.warning = 'Das Jahr liegt sehr weit in der Zukunft.';
    } else {
      result.warning = 'Für dieses Alter gibt es keine passende Lebensphase.';
    }
  }

  return result;
};
